import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import HOMEPAGE from '../../utils/constants/images/homepage';
import * as Styled from './styles';
import { toast } from 'react-toastify';
import clsx from 'clsx';
import Spinner from 'react-bootstrap/Spinner';
import CloseButton from 'react-bootstrap/CloseButton';
import Modal from 'react-bootstrap/Modal';
import { ShouldRender } from 'should-render';

import {
  createMagicInstance,
  getMagicBnBWeb3Provider,
  signWalletTransaction,
} from '../../utils/wallet';
import { validateEmail } from '../../utils/helpers';
import { useConnectWallet } from '../../hooks/useConnectWallet';
import { WalletOption } from '../../../context/AppContext/types';
import OtpInput from 'react-otp-input';
import Lottie from 'react-lottie';
import * as validatingTickAnimation from '../../../public/assets/animations/validatingTickAnimation.json';
import { useWallet } from '../../../context/WalletContext';

import { SignButton } from '../../../src/components/common/Buttons/SignButton';

const animationOptions = {
  loop: false,
  autoplay: true,
  animationData: validatingTickAnimation,
};

interface Props {
  onClose: any;
  setShowWallet: any;
}

const MagicWithdrawal: React.FC<Props> = ({ onClose, setShowWallet }) => {
  const [email, setEmail] = useState('');
  /* eslint-disable */
  const [chain, setChain] = useState('ALGORAND');
  const [showOTPInput, setOTPInput] = useState<any>(false);

  /* eslint-enable */
  const [otp, setOtp] = useState('');
  const [showAnimation, setShowAnimation] = useState(false);
  const [loader, setLoader] = useState(false);
  const [timer, setTimer] = useState<any>(null);
  const magic = createMagicInstance(chain);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isResendLoading, setIsResendLoading] = useState<boolean>(false);
  const { connectWallet } = useConnectWallet();

  const {
    state: { walletManager },
  } = useWallet();

  const handleSendOTP = async () => {
    setIsLoading(true);
    // @ts-ignore:next-line
    if (magic?.user) await magic.user.logout();
    try {
      // @ts-ignore:next-line
      const login = magic?.auth?.loginWithEmailOTP({
        email,
        showUI: false,
      });
      login.on('email-otp-sent', () => {
        // The email has been sent to the user
        setIsResendLoading(false);
        setOTPInput(login);
        countdown(1);
      });
    } catch (err: any) {
      console.log('error in login', err);
      setIsResendLoading(false);
      toast.error(`magic login error:${err?.message}`);
    }
  };
  const handleMagicLogin = async () => {
    //To do: If condition added here as we have commented loginEmail func for disabling calls for metamask and bsc
    if (email.includes('+') || !validateEmail(email)) {
      toast.error('Invalid Email');
    } else {
      handleSendOTP();
    }
  };

  const loginEmail = async () => {
    if (isLoading) return;
    if (email.includes('+') || !validateEmail(email)) {
      toast.error('Invalid Email');
    } else {
      setIsLoading(true);
      handleMagicLogin();
    }
  };

  const handleChange = (newVal: string) => setOtp(newVal);

  const handleMagicLoginVerification = async (
    result: any,
    address: any,
    // genAuthMessage: any,
  ) => {
    try {
      const isMagic = true;
      const web3 = await getMagicBnBWeb3Provider(magic);
      let txData;
      if (isMagic && chain === 'BINANCE') {
        txData = await signWalletTransaction(
          web3,
          address!,
          'test',
          isMagic && chain === 'BINANCE' ? 'MagicBnB' : '',
        );
      } else {
        txData = await walletManager.algoZeroTransaction(
          address,
          0,
          'test',
          null,
          magic,
        );
      }

      console.log('da', txData);
      setLoader(false);
      setShowAnimation(false);
      setShowWallet(true);
      handleClose();
    } catch (error) {
      setIsLoading(false);
      toast.error(error);
    }
  };

  const sendOTPToMagic = () => {
    setLoader(true);
    try {
      showOTPInput.emit('verify-email-otp', otp);
      showOTPInput
        .on('invalid-email-otp', () => {
          setLoader(false);
          toast.error('Incorrect verification code.');
          setOtp('');
        })
        .on('done', async (result: any) => {
          // is called when the Promise resolves
          localStorage.setItem('magicToken', result);
          setShowAnimation(true);
          setTimeout(async () => {
            let publicAddress = '';
            // @ts-ignore:next-line
            const web3 = await getMagicBnBWeb3Provider(magic);
            if (chain === 'BINANCE') {
              publicAddress = (await web3.eth.getAccounts())[0];
              await connectWallet(
                WalletOption.MAGIC,
                publicAddress,
                {},
                web3,
                chain,
              );
            } else {
              // @ts-ignore:next-line
              publicAddress = await magic.algorand.getWallet();
              await connectWallet(WalletOption.MAGIC, publicAddress, {});
            }
            if (publicAddress) {
              handleMagicLoginVerification(result, publicAddress);
            }
          }, 3000);
        })
        .on('error', (reason: any) => {
          setLoader(false);
          // is called if the Promise rejects
          console.error(reason);
          toast.error(reason);
        });
    } catch (err: any) {
      toast.error(`error in magic otp verification: ${err?.message}`);
    }
  };

  useEffect(() => {
    if (otp?.length > 5) {
      sendOTPToMagic();
    }
  }, [otp]);
  const handleResendOTP = async () => {
    try {
      await showOTPInput.emit('cancel');
      setIsResendLoading(true);
      handleSendOTP();
    } catch (err: any) {
      setIsResendLoading(false);
      toast.error(`resend err: ${err?.message}`);
    }
  };
  const countdown = (minutes: any = 2) => {
    let seconds = 60;
    let mins = minutes;
    function tick() {
      let currentMinutes = mins - 1;
      seconds--;
      const counter =
        (currentMinutes < 10 ? '0' : '') +
        currentMinutes.toString() +
        ':' +
        (seconds < 10 ? '0' : '') +
        String(seconds) +
        's';
      setTimer(counter);
      if (seconds > 0) {
        setTimeout(tick, 1000);
      } else {
        if (mins > 1) {
          countdown(mins - 1);
        } else {
          setTimer(null);
        }
      }
    }
    tick();
  };

  const handleClose = () => {
    onClose(false);
    setOTPInput(false);
  };

  const addMobileClass =
    (!showAnimation && !showOTPInput) || (!showAnimation && !showOTPInput);

  const handleChainSelect = (val: any) => {
    if (!val) return;
    setChain(val);
  };
  return (
    <>
      <div>
        <Styled.CustomModal
          fullscreen={'sm'}
          centered
          show
          onHide={handleClose}
        >
          <Modal.Body>
            <Styled.LoginSignUpContainer
              className={clsx(addMobileClass && 'negativeMargin')}
            >
              <Styled.Header className={clsx(addMobileClass && 'hideBorder')}>
                <Styled.Title
                  className={clsx(addMobileClass && 'hideLoginTitle')}
                >
                  {showAnimation
                    ? 'Validating'
                    : showOTPInput
                    ? 'Enter OTP'
                    : 'Log in'}
                </Styled.Title>
                {!showOTPInput && (
                  <Styled.CloseButtonWrapper>
                    <CloseButton variant="white" onClick={handleClose} />
                  </Styled.CloseButtonWrapper>
                )}
              </Styled.Header>

              {showAnimation ? (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <Lottie
                    options={animationOptions}
                    height={238}
                    width={238}
                    isStopped={false}
                    isPaused={false}
                  />
                </div>
              ) : showOTPInput ? (
                <div className="d-flex mt-2 flex-column align-items-center justify-content-center h-100 w-100">
                  <Image
                    src={HOMEPAGE.email}
                    height={'39'}
                    width={'39'}
                    alt={'email'}
                  />
                  <Styled.Title className="my-4 text-center">
                    {`Please enter the code sent to ${email}`}
                  </Styled.Title>
                  {loader ? (
                    <Styled.LoaderWrapper>
                      <Spinner animation="border" variant="secondary" />
                    </Styled.LoaderWrapper>
                  ) : (
                    <>
                      <OtpInput
                        containerStyle={{
                          height: '50px',
                          width: '297px',
                          justifyContent: 'space-between',
                        }}
                        value={otp}
                        onChange={handleChange}
                        numInputs={6}
                        inputStyle={{
                          height: '42px',
                          width: '37px',
                          background: '#282D33',
                          border: '1px solid rgba(255, 255, 255, 0.3)',
                          borderRadius: '6px',
                          color: 'white',
                          fontWeight: '600',
                          fontSize: '24px',
                          lineHeight: '36px',
                        }}
                        focusStyle={{
                          outline: 'unset',
                        }}
                      />
                      <Styled.ResendTitleWrapper>
                        <span className={clsx(timer && 'w-50 text-right')}>
                          Didn&apos;t receive OTP?
                        </span>
                        <span
                          onClick={() => {
                            if (!timer) {
                              handleResendOTP();
                            }
                          }}
                          className={clsx('ml-1', timer ? 'w-50' : 'resendBtn')}
                        >
                          {isResendLoading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            'Resend'
                          )}
                          <span className={clsx(!timer && 'd-none')}>
                            {' in '} <span className={'timer'}>{timer}</span>
                          </span>
                        </span>
                      </Styled.ResendTitleWrapper>
                    </>
                  )}
                </div>
              ) : (
                <div className="mt-2  w-100 h-100 d-flex flex-column align-items-center justify-content-center">
                  <Styled.Title
                    className="mt-2"
                    style={{
                      fontWeight: '600',
                      fontSize: '18px',
                    }}
                  >
                    Sign in using email
                  </Styled.Title>
                  <div
                    className="my-2"
                    style={{
                      fontWeight: '400',
                      fontSize: '14px',
                      color: 'rgba(255, 255, 255, 0.70)',
                      textAlign: 'center',
                    }}
                  >
                    SIgn in using your email to access your magic wallet and
                    send your funds to a different wallet.
                  </div>
                  <>
                    <Styled.Title className="subTitle">
                      Select Your Preferred Chain
                    </Styled.Title>
                    <Styled.ChainsContainer className="w-100">
                      <Styled.BlockChainWrapper
                        onClick={() => handleChainSelect('BINANCE')}
                        className={clsx(chain === 'BINANCE' && 'selected')}
                      >
                        <Styled.RadioButton
                          type={'radio'}
                          value={'BINANCE'}
                          checked={chain === 'BINANCE'}
                          onChange={(e: any) => {
                            // @ts-ignore:next-line
                            handleChainSelect(e?.target?.value);
                          }}
                          label={
                            <Image
                              src={HOMEPAGE.binanceSmartChain}
                              height={'24'}
                              width={'90'}
                              alt={'binance'}
                            />
                          }
                        />
                      </Styled.BlockChainWrapper>
                      <Styled.BlockChainWrapper
                        onClick={() => handleChainSelect('ALGORAND')}
                        className={clsx(
                          'mt-3',
                          chain === 'ALGORAND' && 'selected',
                        )}
                      >
                        <Styled.RadioButton
                          type={'radio'}
                          value={'ALGORAND'}
                          checked={chain === 'ALGORAND'}
                          onChange={(e: any) => {
                            // @ts-ignore:next-line
                            handleChainSelect(e?.target?.value);
                          }}
                          label={
                            <Image
                              src={HOMEPAGE.algorandNew}
                              height={'20'}
                              width={'73'}
                              alt={'algorand'}
                            />
                          }
                        />
                      </Styled.BlockChainWrapper>
                    </Styled.ChainsContainer>
                  </>
                  <Styled.InputWrapper className="w-100 my-4">
                    <input
                      type="email"
                      name="email"
                      className="mt-1 bg-black  py-[12px] text-sm px-[14px] rounded-[10px] border border-gray-900 border-opacity-50 w-full text-white"
                      required={true}
                      placeholder="Enter Your Email"
                      onChange={event => {
                        setEmail(event?.target?.value);
                      }}
                    />
                    <Styled.IconWrapper>
                      <Image
                        src={HOMEPAGE.magicIcon}
                        height={'25'}
                        width={'30'}
                        alt={'magicIcon'}
                      />
                    </Styled.IconWrapper>
                  </Styled.InputWrapper>

                  <ShouldRender if={isLoading}>
                    <SignButton className="disabled">
                      <Spinner animation="border" size="sm" />
                    </SignButton>
                  </ShouldRender>
                  <ShouldRender if={!isLoading}>
                    <SignButton
                      className={'get-wallet-btn my-2'}
                      onClick={loginEmail}
                    >
                      Continue
                    </SignButton>
                  </ShouldRender>
                </div>
              )}
            </Styled.LoginSignUpContainer>
          </Modal.Body>
        </Styled.CustomModal>
      </div>
    </>
  );
};

export default MagicWithdrawal;
